var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMyPayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.83325 4.125H8.0275C8.75685 4.125 9.45634 4.41473 9.97206 4.93046L12.8333 7.79167",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58325 12.375H1.83325",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79159 6.875L9.62492 8.70833C10.1312 9.21461 10.1312 10.0354 9.62492 10.5417C9.11866 11.0479 8.29785 11.0479 7.79159 10.5417L6.41659 9.16667C5.62762 9.95564 4.37857 10.0444 3.48595 9.37493L3.20825 9.16667",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.58325 10.0833V14.2083C4.58325 15.9368 4.58325 16.801 5.12023 17.338C5.65719 17.875 6.52143 17.875 8.24992 17.875H16.4999C18.2284 17.875 19.0926 17.875 19.6296 17.338C20.1666 16.801 20.1666 15.9368 20.1666 14.2083V11.4583C20.1666 9.72983 20.1666 8.86556 19.6296 8.3286C19.0926 7.79163 18.2284 7.79163 16.4999 7.79163H8.70825",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9791 12.8333C13.9791 13.7193 13.2609 14.4375 12.3749 14.4375C11.489 14.4375 10.7708 13.7193 10.7708 12.8333C10.7708 11.9473 11.489 11.2291 12.3749 11.2291C13.2609 11.2291 13.9791 11.9473 13.9791 12.8333Z",
    stroke: "#423F5A",
    strokeWidth: 1.375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyPayments);
export default __webpack_public_path__ + "static/media/my-payments.624ad9b3877148bbab103b4218a0886a.svg";
export { ForwardRef as ReactComponent };